import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
export function Guarantee() {
  return <section className="bg-white px-3 py-3 sm:px-4 sm:py-4" data-id="element-91" data-mp="1o33tsfx1zqh8">
      <div className="mx-auto flex max-w-3xl items-start gap-2.5 rounded-xl border border-pf-creamDark bg-pf-cream p-3 shadow-sm" data-id="element-92" data-mp="223y3r2zr1zi0">
        <ShieldCheckIcon className="h-7 w-7 shrink-0 text-pf-coral" aria-hidden="true" data-id="element-93" data-mp="1x5msqoxpxiy7" />
        <div data-id="element-94" data-mp="19fsh2ap4y0fj">
          <h2 className="mb-0.5 font-display text-base font-extrabold uppercase leading-tight tracking-tight sm:text-3xl" data-id="element-95" data-mp="19fadet058jxl">
            Your Purchase Is 100% Protected
          </h2>
          <p className="text-[12px] font-medium leading-snug text-pf-ink sm:text-base" data-id="element-96" data-mp="1j5lsnbpa2fjs">
            Try {PRODUCT_NAME} for 14 full days. Explore the complete modules, exercise resources,
            sessions, programming systems, coaching tools and premium bonuses. Start integrating the
            resources into your own professional planning process. If you decide the system isn’t
            right for you, contact us within 14 days for a full refund according to the refund terms.{' '}
            <span className="font-bold text-pf-navy" data-id="element-97" data-mp="txkuz618zc15">
              You can explore the complete system without taking the full risk yourself.
            </span>
          </p>
        </div>
      </div>
    </section>;
}